import { Outlet } from 'react-router-dom';
import ErrorBoundary from '~/components/ErrorBoundary';
import { useGetUserQuery } from '~/redux/api/userApiSlice';
import { useGetUserProfileQuery } from '~/redux/api/authApiSlice';

const AuthLayout = () => {
  const { isLoading, isError } = useGetUserQuery();
  useGetUserProfileQuery();

  return (
    <ErrorBoundary isError={!isLoading && isError}>
      <Outlet />
    </ErrorBoundary>
  );
};

export default AuthLayout;
